import type { GlbHierarchyNode } from './glb'
import type { ImportedModelResult } from './types'

/**
 * 解析导入模型结果对应的权威 hierarchy。
 *
 * 设计原则：
 * 1. hierarchy 的语义真相必须以加载阶段已经构建好的结果对象为准；
 * 2. 宿主层不得再从运行时 scene root / object 反推 hierarchy，
 *    否则会把 runtime wrapper、场景挂载根等非语义节点重新采集进设计树；
 * 3. 该函数作为 imported-model 模块对外暴露的统一入口，收口 hierarchy 来源。
 *
 * @param result 导入模型加载结果。
 * @returns 供设计树、选择映射等上层逻辑消费的权威 hierarchy。
 */
export function resolveImportedModelHierarchy(
  result: ImportedModelResult,
): GlbHierarchyNode {
  return result.hierarchy
}
